import {
  AmazonIcon,
  BookliveIcon,
  DbookIcon,
  EcIcon,
  EhonIcon,
  HontoEbookIcon,
  HontoIcon,
  HonyaClubIcon,
  KeibundoIcon,
  KindleIcon,
  KinokuniyaIcon,
  MaruzenIcon,
  MibonEbookIcon,
  MibonEcIcon,
  Omni7Icon,
  RakutenIcon,
  TsutayaIcon,
} from '@/components/icon'

interface Props {
  name: string
}
export const RenderShop: React.FC<Props> = ({ name }) => {
  const style = 'w-[50px] bg-white border border-[#e3e3e3] border-solid'
  const shops = [
    { name: 'amazon', icon: AmazonIcon },
    { name: 'kindle', icon: KindleIcon },
    { name: 'sevennet', icon: Omni7Icon },
    { name: 'ehon', icon: EhonIcon },
    { name: 'kinokuniya', icon: KinokuniyaIcon },
    { name: 'honyaclub', icon: HonyaClubIcon },
    { name: 'rakuten', icon: RakutenIcon },
    { name: 'honto', icon: HontoIcon },
    { name: 'honto_epub', icon: HontoEbookIcon },
    { name: 'mibon', icon: MibonEcIcon },
    { name: 'mibon_e', icon: MibonEbookIcon },
    { name: 'docomo', icon: DbookIcon },
    { name: 'booklive', icon: BookliveIcon },
    { name: 'tsutaya', icon: TsutayaIcon },
    { name: 'maruzen', icon: MaruzenIcon },
    { name: 'keibundo', icon: KeibundoIcon },
  ]
  const Icon = shops.find((v) => v.name === name)?.icon
  if (!Icon) return <EcIcon className={style} />
  return <Icon className={style} />
}
